import { render, staticRenderFns } from "./LatestRequestsChart.vue?vue&type=template&id=38ac1f37&"
import script from "./LatestRequestsChart.vue?vue&type=script&lang=js&"
export * from "./LatestRequestsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports